<template>
    <div>
        <label><mu-icon style="vertical-align:middle;" value="insert_emoticon" :size="32"/>图标</label>
    </div>
</template>
<script>
export default {
    name: 'icon'
}
</script>



// WEBPACK FOOTER //
// icon.vue?70ba31a5